// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"citaat-module--wrapper--2Ynzs","citaat":"citaat-module--citaat--2Ioxd","credit":"citaat-module--credit--2VjnS"};